import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import C決算期TableHeader from '@/components/決算期TableHeader/決算期TableHeader.vue';

import MoneyUnitLabelMixin from '@/entries/user/mixins/MoneyUnitLabelMixin';

import { 決算期TableHeader } from '@/classes/common/決算期Utility';

export default mixins(MoneyUnitLabelMixin).extend({
  name: 'MoneyUnit決算期TableHeader',

  components: {
    C決算期TableHeader,
  },

  props: {
    list: {
      type: Array as PropType<決算期TableHeader[]>,
      required: true,
    },
    colspan: {
      type: Number,
      default: 1,
    },
  },
});
